import UUID from 'uuid';
import { ISunnyRequestBuilderConstructor, SunnyRequestBuilder } from '@/models/Common/SunnyRequestBuilder';
import { IRequestWrap } from '@/server/IServer';
import { TReqConfigValidated } from '@/services/JSCService';
import { Either } from 'tsmonad';

export default class FeJourneyRequestBuilder extends SunnyRequestBuilder {
  static fromReq<T extends SunnyRequestBuilder>(this: ISunnyRequestBuilderConstructor<T>, req: IRequestWrap): T {
    if (!req || !req.config) {
      return new this();
    }

    const device = req.ua.getDevice();

    return new this({
      accessToken: req.config.FeJourneyAPIAccessToken,
      baseURI: this.getBaseURIFromReq(req),
      cgntId: req.cookies['cgntId'] || req.sunnyMeta['cgntId'],
      clientIP: (req.headers['x-forwarded-for'] as string) || req.connection.remoteAddress,
      platform: device.type === 'mobile' || device.type === 'tablet' ? 'MWeb' : 'Web',
      userAgent: req.ua.getUA(),
      ywt: req.session.getYWT(),
      testProduct: req.session.getSettings?.().testProduct,
      traceID: (req.headers['X-Trace-Id'] as string) || UUID.v4(),
      expGroups: req.serviceConfig?.serverExpGroups ?? '',
    });
  }

  static getBaseURIFromReq(req: IRequestWrap): URI {
    return req.config.FeJourneyAPI;
  }

  createPostLiveCommerceToken(): TReqConfigValidated {
    return Either.right(this.makeConfig('GET', '/member/live-broadcast/access-token'));
  }

  protected getAPIEndpoint(path: string): string {
    const baseURI = this.baseURI.href();
    return baseURI ? `${baseURI}${path}` : `${baseURI}/api/v1${path}`;
  }
}
